/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ShopifyAppControllerDeleteSession$Params {
  shopifySessionId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function shopifyAppControllerDeleteSession(
  http: HttpClient,
  rootUrl: string,
  params: ShopifyAppControllerDeleteSession$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerDeleteSession.PATH, 'delete');
  if (params) {
    rb.path('shopifySessionId', params.shopifySessionId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

shopifyAppControllerDeleteSession.PATH = '/api/v1/shopify-app/sessions/{shopifySessionId}';
